<template>
    <div class="container">
        <div id="action-container">
            <div class="group left-group">
                <h2 class="title">
                  Let's help you pick the right classes for your next quarter
                </h2>
                <p class="subtitle">Sign up for exclusive course insights and career tips</p>

                <form @submit.prevent="registerEmail">
                    <input v-model="email" type="email" id="email-input-one" placeholder="Your Email" required />
                    <button type="submit" id="email-button-one">Sign Up</button>
                </form>
                <!-- <form @submit.prevent="registerEmail">
                    <input
                        v-model="email"
                        type="email"
                        id="email-input-two"
                        placeholder="Sign up for course updates"
                        required
                    />
                    <button type="submit" id="email-button-two">
                        <span class="icon">
                            <i class="fas fa-check"></i>
                        </span>
                    </button>
                </form> -->
            </div>
            <div class="right-group group">
                <img id="banner-image" src="../../assets/visuals/desk.svg" />
            </div>
        </div>
    </div>

</template>

<script>
import { firestore } from "@/firebase.js";

export default {
    // This is the name of our component
    name: "HomeBannerDesktop",

    data() {
        return {
            email: ""
        }
    },

    // Methods that can be bound to our HTML
    methods: {
        registerEmail() {
            let tmp = {
                email: this.email,
                date: new Date()
            };

            firestore.collection("emails").add(tmp);
            this.email = "";
            this.$swal("Thank You!", "We'll keep you posted with exciting future updates", "success");

			// Post a Google Analytics update
            this.$gtag.event('button_click', {
              'event_category': 'Email Button Clicked',
              'event_label': 'Email Sign Up',
              'value': 0
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";

/// Calculate the least square fit linear regression of provided values
/// @param {map} $map - A SASS map of viewport width and size value combinations
/// @return Linear equation as a calc() function
@function least-squares-fit($map) {

    // Get the number of provided breakpoints
    $length: length(map-keys($map));

    // Error if the number of breakpoints is < 2
    @if ($length < 2) {
        @error "leastSquaresFit() $map must be at least 2 values"
    }

    // Calculate the Means
    $resTotal: 0;
    $valueTotal: 0;
    @each $res, $value in $map {
        $resTotal: $resTotal + $res;
        $valueTotal: $valueTotal + $value;
    }
    $resMean: $resTotal/$length;
    $valueMean: $valueTotal/$length;

    // Calculate some other stuff
    $multipliedDiff: 0;
    $squaredDiff: 0;
    @each $res, $value in $map {
        // Differences from means
        $resDiff: $res - $resMean;
        $valueDiff: $value - $valueMean;

        // Sum of multiplied differences
        $multipliedDiff: $multipliedDiff + ($resDiff * $valueDiff);

        // Sum of squared resolution differences
        $squaredDiff: $squaredDiff + ($resDiff * $resDiff);
    }

    // Calculate the Slope
    $m: $multipliedDiff / $squaredDiff;

    // Calculate the Y-Intercept
    $b: $valueMean - ($m * $resMean);

    // Return the CSS calc equation
    @return calc(#{$m*100}vw + #{$b}px);
}

#action-container {
    background-color: #ffc4b7;
    border-radius: 12px;
    display: flex;
    flex-direction: row;
    overflow: hidden;

    #banner-image {
        width: 90%;
    }

    form {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
    }

    .group {
        width: 50%;
    }

    .left-group {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 50px;

        #email-input-one,
        #email-button-one,
        #email-input-two,
        #email-button-two {
            margin-top: 5px;
        }

        #email-input-one {
            width: 50%;
        }
    }

    .right-group {
        display: flex;
        flex-direction: column-reverse;
    }
}

.container {
    padding: 5px 8%;
}

#email-input-one,
#email-input-two {
    background-color: #fffbf8;
    border-radius: 12px;
    width: 283px;
    height: 28px;

    margin-right: 10px;
    padding: 10px 20px;
    outline: none;
    border: none;
}

#email-button-one,
#email-button-two {
    width: 107px;
    height: 48px;
    background: #eb5757;
    color: white;
    border-radius: 12px;
    border: none;
    outline: none;

    &:active {
        background: #cb3737;
    }
}

@media only screen and (min-width: 1000px) {
    h2 {
        $map: (1050: 25, 1100: 27, 1200: 30, 1440: 36);
        font-size: least-squares-fit($map);
    }
}
</style>
